// © 2015-2021 WDNA - All Rights Reserved

import { UserDO } from 'wdna-components/lib/types.new';

import {
  AUTH_USER,
  REMOVE_USER,
  RxAction
} from './actions';

export type RxState = {
  user?: UserDO;
}

const INITIAL_STATE: RxState = { user: undefined };
const DEFAULT_ACTION: RxAction = { type: '' };

/**
 * Reducer to manage authorization actions
 *
 * @param state inital estate to update
 * @param action next action to perform
 * @returns action object to response
 */
export default function reducer(state: RxState = INITIAL_STATE, action: RxAction = DEFAULT_ACTION): RxState {
  switch (action.type) {
    case AUTH_USER:
      return { user: action.user };

    case REMOVE_USER:
      return INITIAL_STATE;

    default:
      return state;
  }
}
